import {ActivatedRouteSnapshot, CanActivateChildFn, Router} from '@angular/router';
import {PermissionContextService} from "../../service/context/permission-context.service";
import {inject} from "@angular/core";

export const permissionGuard: CanActivateChildFn = (route) => {
  const permissionContext = inject(PermissionContextService);
  const router = inject(Router);

  let current: ActivatedRouteSnapshot | null = route;

  while (current) {
    const permissions = current.data['permission'];

    if (permissions) {
      const perms = Array.isArray(permissions)
        ? permissions
        : [permissions];

      if (!permissionContext.hasAny(perms)) {
        return router.createUrlTree(['/unauthorized']);
      }
    }

    current = current.parent;
  }

  return true;
};
